export default __webpack_public_path__ + "static/media/click.9f02c7e2.mp3";